var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-pagination',{attrs:{"total":_vm.pageCount,"max":_vm.pageCount > 9 ? 9 : _vm.pageCount,"vs-type":"flex"},on:{"change":function($event){return _vm.handlePageChange(_vm.meta.current_page)}},model:{value:(_vm.meta.current_page),callback:function ($$v) {_vm.$set(_vm.meta, "current_page", $$v)},expression:"meta.current_page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }